import { API_HOST } from '../constants/env';

const redirectToLogin = () => {
    window.location.href = API_HOST + '/oauth2/authorization/authentik';
};

export default redirectToLogin;
